<style>
.w150 {
  min-width: 150px;
  display: inline-block;
}
</style>
<template>
  <v-container style="max-width: 1000px;" class="pa-0 pa-md-4">
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6" disable-icon-rotate>
          {{ items[0].title }}
          <template v-slot:actions>
            <v-icon :color="items[0].iconColor">
              {{ items[0].icon }}
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>

          <v-expansion-panels multiple v-model="open">
            <v-expansion-panel>
              <v-expansion-panel-header>
                マップ作成
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field clearable v-model="newMap.title"
                              label="*マップタイトル" hint="20文字以内" type="text"
                              prepend-inner-icon="mdi-map" counter="20"
                ></v-text-field>
                <v-textarea filled auto-grow label="マップ説明（2000文字以内）" rows="2"
                            row-height="30" dense counter="2000"
                            v-model="newMap.description"
                ></v-textarea>
                <v-textarea filled auto-grow label="コンテンツ投稿規約（1000文字以内）" rows="2"
                            row-height="30" dense counter="1000"
                            v-model="newMap.postRule"
                ></v-textarea>

                <v-card-text style="text-align: start;" class="ma-0 pb-2">
                  マップサムネイル画像<br>
                  <small>*アップロード可能なファイル形式は「JPG」「PNG」「GIF」「WEBP」です．</small>
                </v-card-text>
                <div class="image-input__field" style="max-width: 600px;" :class="{'over': isDragOver}"
                     @dragover.prevent="onDrag('over')"
                     @dragleave="onDrag('leave')"
                     @drop.stop="onDrop">
                  <input type="file" title @change="onChangeMapImage">
                  ここをクリックしてファイルを選択<br>またはD＆Dでファイルを追加できます
                </div>
                <div class="pb-0 mt-2">
                  <img v-if="mapImage" :src="mapImage" style="object-fit: cover; height: 150px; width: 300px; border-radius: 6px;">
                </div>

                <v-card-text v-if="false" style="text-align: start;" class="ma-0 pb-2">
                  マップヘッダデザイン画像<br>
                  <small>*アップロード可能なファイル形式は「JPG」「PNG」「GIF」「WEBP」です．</small>
                </v-card-text>
                <div v-if="false" class="image-input__field" style="max-width: 600px;" :class="{'over': isDragOver2}"
                     @dragover.prevent="onDrag('over2')"
                     @dragleave="onDrag('leave2')"
                     @drop.stop="onDrop">
                  <input type="file" title @change="onChangeMapDesign">
                  ここをクリックしてファイルを選択<br>またはD＆Dでファイルを追加できます
                </div>
                <div class="pb-0 mt-2">
                  <img v-if="mapDesign" :src="mapDesign" style="object-fit: cover; height: 50px; width: 500px; border-radius: 6px;">
                </div>

                <v-select v-model="newMap.design" :items="DEFINE.design" class="mt-6" style="max-width: 300px;"
                          label="マップデザイン"></v-select>
                <v-select v-model="newMap.show" :items="DEFINE.showMap" style="max-width: 300px;"
                          label="マップ表示" class="mt-4" :hint="DEFINE.showMap[newMap.show].description"></v-select>
                <v-select v-model="newMap.postMethod" :items="DEFINE.postMethods" style="max-width: 300px;"
                          label="位置情報取得方法" class="mt-4"></v-select>
                <v-select v-model="newMap.contributor" :items="DEFINE.contributor" style="max-width: 300px;"
                          label="投稿者" class="mt-4"></v-select>
                <v-select v-model="newMap.nessConfirm" :items="DEFINE.nessConfirm" style="max-width: 300px;"
                          label="投稿承認" class="mt-4"></v-select>
                <v-select v-model="newMap.canComment" :items="DEFINE.canComment" style="max-width: 300px;"
                          label="コメントを許可" class="mt-4" :hint="DEFINE.canComment[newMap.canComment].description"></v-select>
                <v-select v-model="newMap.popruMax" :items="DEFINE.popruMax" style="max-width: 300px;"
                          label="表示ぽっぷる❢数" class="mt-4"></v-select>
                <v-checkbox v-model="newMap.canEval" label="評価（グッド）を許可"></v-checkbox>
                <v-menu :close-on-content-click="false" :nudge-right="40" v-model="menu1"
                        transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="newMap.showStart" label="マップ公開日" style="max-width: 300px;"
                                  prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="newMap.showStart" @input="menu1 = false"></v-date-picker>
                </v-menu>
                <v-menu :close-on-content-click="false" :nudge-right="40" v-model="menu2"
                        transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="newMap.showEnd" label="マップ公開終了日" style="max-width: 300px;"
                                  prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="newMap.showEnd" @input="menu2 = false"></v-date-picker>
                </v-menu>

                <div class="d-flex">
                  <v-spacer/>
                  <v-btn color="primary" @click="addMap">マップ作成</v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                マップ一覧
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table v-model="selectedMaps" :headers="mapsHeader" :items="maps" item-key="map_id" class="elevation-1"
                              hide-default-footer single-select show-select>
                  <template v-slot:item.show="{ item }">
                    {{ item.show == 0 ? '非公開' : item.show == 1 ? '限定公開' : item.show == 3 ? 'ログイン' : '全体公開' }}
                  </template>
                  <template v-slot:item.contributor="{ item }">
                    {{ item.contributor == 0 ? '管理者' : item.contributor == 1 ? '承認' : item.contributor == 2 ? 'ログイン' : '全員' }}
                  </template>
                  <template v-slot:item.nessConfirm="{ item }">
                    {{ item.nessConfirm == 0 ? '不要' : '必要' }}
                  </template>
                  <template v-slot:item.canComment="{ item }">
                    {{ item.canComment == 0 ? '不可' : item.nessConfirm == 1 ? '承認制' : '可能' }}
                  </template>
                  <template v-slot:item.made="{ item }">
                    {{ item.made.split(" ")[0] }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="deleteMap(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card v-if="selectedMap" class="my-2">
                  <v-card-title class="py-1">{{ selectedMap.title }}</v-card-title>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">マップデザイン：</span>{{ googleMapsDesigns[selectedMap.design].text }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">マップ表示：</span>{{ DEFINE.showMap[selectedMap.show].text }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">位置情報取得方法：</span>{{ DEFINE.postMethods[selectedMap.postMethod - 1].text }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">投稿者：</span>{{ DEFINE.contributor[selectedMap.contributor].text }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">投稿承認：</span>
                    {{ selectedMap.nessConfirm == 0 ? '不要' : '必要' }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">コメント：</span>
                    {{ selectedMap.canComment == 0 ? '不可' : selectedMap.nessConfirm == 1 ? '承認制' : '可能' }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">表示「ぽっぷる！」数：</span>
                    {{ selectedMap.popruMax }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">「ぽっぷる！」評価：</span>
                    {{ selectedMap.canEval == 1 ? '許可' : '不可' }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">マップ公開日：</span>{{ selectedMap.showStart.split(" ")[0] }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">マップ公開終了日：</span>{{ selectedMap.showEnd.split(" ")[0] }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">マップ作成日：</span>{{ selectedMap.made }}
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">マップ説明：</span>
                    <div v-if="selectedMap.description" class="px-2">
                      <div v-for="(line,i) of selectedMap.description.split(/\r?\n/g)" :key="i">
                        <div v-if="line" style="line-height: 1.1rem;">{{ line }}</div>
                        <div v-else style="height: 12px;"></div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text class="py-1">
                    <span class="font-weight-bold w150">コンテンツ投稿規約：</span>
                    <div v-if="selectedMap.postRule" class="px-2">
                      <div v-for="(line,i) of selectedMap.postRule.split(/\r?\n/g)" :key="i">
                        <div v-if="line" style="line-height: 1.1rem;">{{ line }}</div>
                        <div v-else style="height: 12px;"></div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text>
                    <router-link target="_blank" :to="'/map/?m=' + selectedMap.map_id">マップへ</router-link>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6" disable-icon-rotate>
          {{ items[1].title }}
          <template v-slot:actions>
            <v-icon :color="items[1].iconColor">
              {{ items[1].icon }}
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card style="max-width: 800px;" class="my-4 mx-auto pa-2" elevation="4" shaped>
            <v-card-title class="pb-1 secondary--text font-weight-bold" color="secondary">
              ぽっぷる❢ 一覧
            </v-card-title>

            <v-card v-for="(popru, i) of userMappoprus" :key="i" class="pa-2 ma-2" elevation="2">
              <v-card-title class="py-0">{{ popru.title }}</v-card-title>
              <v-card-text class="py-0">
                <span style="margin-right: 20px; display: inline-block;">投稿者：{{ popru.userName }}</span>
                <span style="margin-right: 20px; display: inline-block;">投稿先：{{ popru.mapTitle }}</span>
                <span style="margin-right: 20px; display: inline-block;">撮影日時：{{ popru.shootingDate }}</span>
                <span style="margin-right: 20px; display: inline-block;">投稿日時：{{ popru.made }}</span>
              </v-card-text>
              <img :src="imageRoot + popru.image + '_200x200.png'"
                   style="object-fit: contain; height: 150px; width: 200px;"/>
              <v-card-text class="py-0">{{ popru.text }}</v-card-text>
              <v-card-actions class="py-0">
                <v-spacer/>
              </v-card-actions>
              <v-card-actions>
                <v-btn title="未確認" v-if="popru.state == 0" icon @click="changePopruState(popru, 0)">
                  <v-icon color="red">mdi-eye-off</v-icon>
                </v-btn>
                <v-btn title="承認" icon @click="changePopruState(popru, 1)">
                  <v-icon :color="popru.state == 1 ? 'green' : 'grey'">mdi-check</v-icon>
                </v-btn>
                <v-btn title="非表示（承認保留）" icon @click="changePopruState(popru, 2)">
                  <v-icon :color="popru.state == 2 ? 'red' : 'grey'">mdi-cancel</v-icon>
                </v-btn>
                <v-spacer/>
                <v-btn @click="deletePopru(popru)" color="primary" class="px-5">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6" disable-icon-rotate>
          {{ items[2].title }}
          <template v-slot:actions>
            <v-icon :color="items[2].iconColor">
              {{ items[2].icon }}
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card style="max-width: 800px;" class="my-4 mx-auto pa-2" elevation="4" shaped>
            <v-card-title class="pb-1 secondary--text font-weight-bold" color="secondary">
              ぽっぷる❢コメント 一覧
            </v-card-title>

            <v-card v-for="(comment, i) of popruComments" :key="i" class="pa-2 ma-2" elevation="2">
              <v-card-text class="py-0">投稿者：{{ comment.userName }}
                <span style="margin-left: 20px;">{{ comment.made }}</span></v-card-text>
              <v-card-text class="pb-0 pt-2">
                <div v-for="(line,i) of comment.text.split(/\r?\n/g)" :key="i">
                  <template v-if="line">
                    <div style="line-height: 1.1rem;">{{ line }}</div>
                  </template>
                  <template v-else>
                    <div style="height: 12px;"></div>
                  </template>
                </div>
              </v-card-text>
              <v-card-actions class="py-0">
                <v-spacer/>
              </v-card-actions>
              <v-card-actions>
                <v-btn title="未確認" v-if="comment.state == 0" icon @click="changePopruCommentState(comment, 0)">
                  <v-icon color="'red'">mdi-eye-off</v-icon>
                </v-btn>
                <v-btn title="承認" icon @click="changePopruCommentState(comment, 1)">
                  <v-icon :color="comment.state == 1 ? 'green' : 'grey'">mdi-check</v-icon>
                </v-btn>
                <v-btn title="非表示（承認保留）" icon @click="changePopruCommentState(comment, 2)">
                  <v-icon :color="comment.state == 2 ? 'red' : 'grey'">mdi-cancel</v-icon>
                </v-btn>
                <v-spacer/>
                <v-btn @click="deletePopruComment(comment)" color="primary" class="px-5">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6" disable-icon-rotate>
          通知
          <template v-slot:actions>
            <v-icon color="orange">mdi-bell</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-checkbox v-if="false" v-model="notifConf.doNotif" label="通知を送信する"></v-checkbox>
          <v-text-field clearable v-model="notifConf.email"
                        label="*通知先メールアドレス" hint="255文字以内" type="text"
                        prepend-inner-icon="mdi-email" counter="255"
          ></v-text-field>
          <div class="d-flex mt-2">
            <v-spacer/>
            <v-btn color="primary" @click="defineNotif">確定</v-btn>
          </div>
          <div class="d-flex mt-2">
            <v-spacer/>
            <v-btn color="primary" @click="testSendEmail">メール送信テスト</v-btn>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
  </v-container>
</template>

<script>
import "firebase/storage";
import "firebase/firestore";
import {googleMapsDesigns} from "@/plugins/google-map-designs";
import firebase from "@/plugins/firebase";
import loadImage from "blueimp-load-image";

export default {
  created() {
    console.log("created");
    this.newMap = {...this.mapBase};
  },
  async mounted() {
    console.log("mounted admin");
    if (this.isSignedIn && this.user && this.user.rand) {
      this.initialized = true;
      this.init();
    }

    this.googleMapsDesigns = googleMapsDesigns;
    let design = [];
    for (let key in googleMapsDesigns) {
      let _d = googleMapsDesigns[key];
      design.push({
        text: _d.text,
        value: key
      });
    }
    this.DEFINE.design = design;
  },
  beforeDestroy() {
    console.log("beforeDestroy map");
    for (let listener of this.listeners) {
      listener();
    }
    this.listeners = [];
  },
  data() {
    return {
      //setting
      initialized: false,
      listeners: [],//NOTE:Firestoreのリスナー一覧
      isDragOver: false,
      isDragOver2: false,

      mapsHeader: [
        {
          text: 'タイトル',
          align: 'start',
          // sortable: false,
          value: 'title',
        },
        {text: '表示', value: 'show'},
        {text: '投稿者', value: 'contributor'},
        {text: '投稿承認', value: 'nessConfirm'},
        {text: 'コメント', value: 'canComment'},
        {text: 'デザイン', value: 'design'},
        {text: '作成日', value: 'made'},
        {text: '削除', value: 'actions', sortable: false},
      ],
      DEFINE: {
        googleMapsDesigns: {},
        popruMax: [50, 100, 200],
        showMap: [
          {
            text: "非公開",
            value: 0,
            description: "マップの管理者にのみ表示されます．",
          },
          {
            text: "限定公開",
            value: 1,
            description: "許可したユーザにのみ表示されます．",
          },
          {
            text: "全体公開",
            value: 2,
            description: "全てのユーザに公開され，検索の対象になります．",
          },
          {
            text: "ログインユーザに公開",
            value: 3,
            description: "ログインしているユーザにのみ表示されます．",
          },
        ],
        canComment: [
          {
            text: "コメント不可",
            value: 0,
            description: "コメントは投稿できません．",
          },
          {
            text: "承認制",
            value: 1,
            description: "マップ管理者が承認した後に表示されます．",
          },
          {
            text: "許可",
            value: 2,
            description: "投稿した時点で表示されます．",
          },
        ],
        nessConfirm: [
          {
            text: "承認制",
            value: true,
            description: "マップ管理者が承認した後に表示されます．",
          },
          {
            text: "承認不要",
            value: false,
            description: "投稿した時点で表示されます．",
          },
        ],
        contributor: [
          {
            text: "管理者",
            value: 0,
            description: "管理者のみ投稿できます．",
          },
          {
            text: "承認ユーザ",
            value: 1,
            description: "管理者と承認されたユーザのみ投稿できます．",
          },
          {
            text: "ログインユーザ",
            value: 2,
            description: "ログインユーザのみ投稿できます．",
          },
          {
            text: "全てのユーザ",
            value: 3,
            description: "全てのユーザが投稿できます．",
          },
        ],
        design: [],
        postMethods: [
          {
            text: "GPS",
            value: 1
          },
          {
            text: "EXIF（写真データ）",
            value: 2
          },
        ],
      },
      open: [],
      panel: [],
      mapsPanel: [],
      items: [
        {
          title: "マップ",
          icon: "mdi-map",
          iconColor: "orange",
        },
        {
          title: "ぽっぷる❢",
          icon: "mdi-comment",
          iconColor: "blue",
        },
        {
          title: "コメント",
          icon: "mdi-comment",
          iconColor: "green",
        },
      ],
      menu1: false,
      menu2: false,
      mapImage: null,
      mapImageBlob: null,
      mapDesign: null,
      mapDesignBlob: null,
      mapBase: {
        title: "",
        description: "",
        image: "",
        designImage: "",
        show: 2,
        popruMax: 50,
        nessConfirm: false,
        contributor: 0,
        canComment: 2,
        nessCommentConfirm: false,
        canEval: true,
        design: "default",
        showStart: "2021-01-01",
        showEnd: "2100-01-01",
        postRule: "",
        postMethod: 1,
      },
      newMap: {
        title: "",
        description: "",
        image: "",
        show: 2,
        popruMax: 50,
        nessConfirm: false,
        contributor: 0,
        canComment: 2,
        nessCommentConfirm: false,
        canEval: true,
        design: "default",
        showStart: "2021-01-01",
        showEnd: "2100-01-01",
        postRule: "",
        postMethod: 1,
      },
      notifConf: {
        doNotif: false,
        email: ""
      },

      maps: [],
      selectedMaps: [],
      selectedMap: null,
      userMappoprus: [],
      popruComments: [],
    };
  },
  methods: {
    onDrag(type) {
      this.isDragOver = type === "over";
      this.isDragOver2 = type === "over2";
    },
    onDrop() {
      this.isDragOver = false;
      this.isDragOver2 = false;
    },

    async poster(url, arr) {
      if (!this.user.token) {
        this.$store.commit('addMessage', {
          text: "この操作にはログインが必要です．"
        });
        return false;
      }
      let params = new URLSearchParams();
      params.append("token", this.user.token);
      params.append("data", JSON.stringify(arr));
      return await this.axios.post(url, params).then(response => {
        return response.data;
      }).catch(error => {
        this.$store.commit('addMessage', {
          text: error
        });
        return false;
      });
    },
    init: function () {
      console.log("init");
      this.$store.commit('set', {
        key: "title",
        val: "管理者"
      });
      //リッスン開始
      this.startCommentListen();
      this.startPopruListen();
      this.getMaps();
      // this.getPoprus();
      // this.getPopruComments();
    },
    makeImageUrl(url) {
      return url.split(".")[0];
    },
    isMail(address) {
      let regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
      if (address.match(regex)) {
        return true;
      }
      return false;
    },
    regImageBase_Sync(filename, data) {
      let blob = data;
      return new Promise((resolve, reject) => {
        if (!blob) {
          blob = null;
          alert("登録画像が選択されておりません．");
          reject(false);
        }
        //ex) "public/thumbnail/"
        firebase.storage().ref().child(filename).put(blob).then(() => {
          resolve(true);
        }).catch(error => {
              alert("画像の登録に失敗しました．：" + error);
              reject(false);
            }
        );
      });
    },
    deleteFolderContents(path) {
      // const storageRef = firebase.storage().ref('temp');
      // storageRef.listAll().then((listResults) => {
      //   const promises = listResults.items.map((item) => {
      //     return item.delete();
      //   });
      //   Promise.all(promises);
      // });
      const ref = firebase.storage().ref(path);
      ref.listAll().then(dir => {
        dir.items.forEach(fileRef => {
          console.log(ref.fullPath);
          this.deleteFile(ref.fullPath, fileRef.name);
        });
        dir.prefixes.forEach(folderRef => {
          console.log(folderRef.fullPath);
          this.deleteFolderContents(folderRef.fullPath);
        });
      }).catch(error => {
        console.log(error);
      });
    },
    deleteFile(pathToFile, fileName) {
      const ref = firebase.storage().ref(pathToFile);
      const childRef = ref.child(fileName);
      childRef.delete();
    },
    deleteFireStorageImage(path) {//ファイル名
      return new Promise((resolve, reject) => {
        firebase.storage().ref().child(path).delete().then(function () {
          resolve(true);
        }).catch(function (error) {
          if (error.code != "storage/object-not-found") {
            reject(false);
          } else {//見つからないときのみ継続して削除処理
            resolve(true);
          }
        });
      });
    },
    deleteFireStorageImages(name) {
      //todo task一括処理
      let size = ["100x100", "200x200", "1280x720"];
      let filetypes = ["png", "webp"];
      for (let f of filetypes) {
        for (let s of size) {
          let filename = name + "_" + s + "." + f;
          this.deleteFireStorageImage(filename);
        }
      }
    },
    async startCommentListen() {
      let self = this;
      console.log(this.user.rand);
      let listener = await firebase.firestore().collection("comments").where("owner", "==", this.user.rand).orderBy("timestamp", "desc").limit(500).onSnapshot(function () {
        setTimeout(self.getPopruComments, 5000);
      }, async function (error) {
        console.log(error);
      });
      this.listeners.push(listener);
    },
    async startPopruListen() {
      let self = this;
      let listener = await firebase.firestore().collection("poprus").where("owner", "==", this.user.rand).orderBy("timestamp", "desc").limit(500).onSnapshot(function () {
        setTimeout(self.getPoprus, 5000);
      }, async function (error) {
        console.log(error);
      });
      this.listeners.push(listener);
    },
    makeRand(l) {
      let c = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let cl = c.length;
      let r = "";
      for (let i = 0; i < l; i++) {
        r += c[Math.floor(Math.random() * cl)];
      }
      return r;
    },

    async onChangeMapImage(event) {
      const files = event.target.files;

      this.mapImage = null;
      this.mapImageBlob = null;
      let file = files[0];
      if (file.type.indexOf('image') < 0) {
        this.image.error = true;
        this.image.errorText = `対応する形式のファイルのみ使用してください．`;
        return;
      }
      let res = await this.readImage(file, 1500, 1500, 2);
      this.mapImage = res[0];
      this.mapImageBlob = res[1];
    },
    async onChangeMapDesign(event) {
      const files = event.target.files;

      this.mapDesign = null;
      this.mapDesignBlob = null;
      let file = files[0];
      if (file.type.indexOf('image') < 0) {
        this.image.error = true;
        this.image.errorText = `対応する形式のファイルのみ使用してください．`;
        return;
      }
      let res = await this.readImage(file, 1500, 1500, 2);
      this.mapDesign = res[0];
      this.mapDesignBlob = res[1];
    },
    async readImage(file, maxW = 1500, maxH = 1500, maxS = 2) {
      if (!file) {
        return;
      }
      let options = {
        canvas: true,
      };
      let exifData = await loadImage.parseMetaData(file).then(function (data) {
            if (data.exif) {
              return data.exif;
            } else {
              return null;
            }
          }
      );
      if (exifData) {
        let exifAll = exifData.getAll();
        if (exifAll.Orientation) {
          options.orientation = exifAll.Orientation;
        }
      }
      let mb = Math.round(file.size / 1024 / 1024);
      if (mb >= maxS) {
        options.maxWidth = maxW;
        options.maxHeight = maxH;
      }

      let data = await loadImage(file, options);
      let imageData = data.image.toDataURL();

      if (data.image.toBlob) {
        return [imageData, await new Promise(resolve => data.image.toBlob(resolve))];
      } else if (data.image.msToBlob) {
        return [imageData, data.image.msToBlob()];
      } else {
        this.$store.commit('addMessage', {
          text: `お使いの端末は画像の投稿に対応しておりません．端末，ブラウザの変更，更新をお試しください．`
        });
      }
    },
    async getPoprus() {
      let res = await this.poster(this.apiRoot + 'admin/getMapPoprus.php', {});
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.selectedPopru = null;
      let poprus = [];
      for (let popru of res.data) {
        poprus.push(popru);
      }
      console.log("popru loaded");
      this.userMappoprus = poprus;
    },
    async changePopruState(popru, val) {
      let res = await this.poster(this.apiRoot + 'popru/changePopruState.php', {
        id: popru.id,
        state: val,
      });
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.getPoprus();
    },
    async deletePopru(popru) {
      let res = await this.$swal.fire(
          {
            title: "本当に削除しますか？",
            html: "この操作は取り消すことができません",
            icon: "question",//"success", "error", "warning", "info" or "question"
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "OK"
          }
      ).then((result) => {
        if (result.value) {
          return true;
        } else {
          return false;
        }
      });
      if (!res) {
        return;
      }

      //画像削除
      this.deleteFireStorageImages(popru.image);

      res = await this.poster(this.apiRoot + 'popru/deletePopru.php', {
        id: popru.id,
      });
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }

      firebase.firestore().collection("poprus").where("popru_id", "==", popru.id + "").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          firebase.firestore().collection("poprus").doc(doc.id).delete().then(() => {
          }).catch((error) => {
            console.error(error);
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
      this.getPoprus();
    },
    async addMap() {
      let map = this.newMap;
      if (!map.title) {
        this.$store.commit('addMessage', {
          text: "マップタイトルは必須項目です"
        });
        return;
      }
      if (map.showStart > map.showEnd) {
        this.$store.commit('addMessage', {
          text: "マップの公開期間が不正です"
        });
        return;
      }

      let res;
      let fileName = "";
      if (this.mapImage) {
        fileName = "public/min/map/thumbnail/";
        if (this.user.rand) {
          fileName += this.user.rand + Math.floor((new Date()).getTime() / 1000);
        } else {
          fileName += this.rand + this.makeRand(10) + Math.floor((new Date()).getTime() / 1000);
        }
        fileName += ".png";
        res = await this.regImageBase_Sync(fileName, this.mapImageBlob).catch((res) => {
          return res;
        });
        fileName = fileName.split(".")[0];
      }
      let fileName2 = "";
      if (this.mapDesign) {
        fileName2 = "public/min/map/design/";
        if (this.user.rand) {
          fileName2 += this.user.rand + Math.floor((new Date()).getTime() / 1000);
        } else {
          fileName2 += this.rand + this.makeRand(10) + Math.floor((new Date()).getTime() / 1000);
        }
        fileName2 += ".png";
        res = await this.regImageBase_Sync(fileName2, this.mapDesign).catch((res) => {
          return res;
        });
        fileName2 = fileName2.split(".")[0];
      }
      map.image = fileName;
      map.designImage = fileName2;

      res = await this.poster(this.apiRoot + 'map/addMap.php', map);
      // console.log(res);
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.newMap = {...this.mapBase};
      this.mapImage = null;
      this.mapImageBlob = null;
      this.mapDesign = null;
      this.mapDesignBlob = null;
      this.$store.commit('addMessage', {
        text: "マップを作成しました",
        risk: 0
      });
      this.getMaps();
    },
    async getMaps() {
      let res = await this.poster(this.apiRoot + 'map/getMaps.php', {});
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      // console.log(res);
      this.maps = res.data;
    },
    async deleteMap(map) {
      let res = await this.$swal.fire(
          {
            title: "本当に削除しますか？",
            html: "この操作は取り消すことができません",
            icon: "question",//"success", "error", "warning", "info" or "question"
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "OK"
          }
      ).then((result) => {
        if (result.value) {
          return true;
        } else {
          return false;
        }
      });
      if (!res) {
        return;
      }

      //delte file
      this.deleteFolderContents("public/min/" + map.map_id);

      res = await this.poster(this.apiRoot + 'map/deleteMap.php', {
        id: map.map_id
      });
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.$store.commit('addMessage', {
        text: "削除しました",
        risk: 0
      });
      this.getMaps();
    },
    async getPopruComments() {
      let res = await this.poster(this.apiRoot + 'admin/getPopruComments.php', {});
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      // console.log(res);
      console.log("comment loaded");
      this.popruComments = res.data;
    },
    async deletePopruComment(item) {
      let res = await this.$swal.fire(
          {
            title: "本当に削除しますか？",
            html: "この操作は取り消すことができません",
            icon: "question",//"success", "error", "warning", "info" or "question"
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "OK"
          }
      ).then((result) => {
        if (result.value) {
          return true;
        } else {
          return false;
        }
      });
      if (!res) {
        return;
      }

      res = await this.poster(this.apiRoot + 'admin/deletePopruComment.php', {
        id: item.id
      });
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.$store.commit('addMessage', {
        text: "削除しました"
      });
      // console.log(res);
      this.getPopruComments();
    },
    async changePopruCommentState(item, val) {
      let res = await this.poster(this.apiRoot + 'admin/changePopruCommentState.php', {
        id: item.id,
        state: val,
      });
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      // console.log(res);
      this.getPopruComments();
    },
    async defineNotif() {
      if (this.notifConf.email && !this.isMail(this.notifConf.email)) {
        this.$store.commit('addMessage', {
          text: "正しいメールアドレスを入力してください"
        });
        return;
      }
      let res = await this.poster(this.apiRoot + 'admin/updateNotifConf.php', {
        do: this.notifConf.doNotif,
        email: this.notifConf.email,
      });
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.$store.commit('addMessage', {
        text: "更新しました",
        risk: 0
      });
    },
    async testSendEmail() {
      let res = await this.poster(this.apiRoot + 'admin/emailSendTest.php', {});
      if (!res) {
        return;
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }
      this.$store.commit('addMessage', {
        text: "テストメールを送信しました．正しく届いているか確認してください．",
        risk: 0
      });
    },
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    endFirstAuth: function () {
      return this.$store.getters.endFirstAuth;
    },
    isSignedIn: function () {
      return this.$store.getters.isSignedIn;
    },
    title: function () {
      return this.$store.getters.get.title;
    },
    imageRoot: function () {
      return this.$store.getters.get.imageRoot;
    },
    apiRoot: function () {
      return this.$store.getters.get.apiRoot;
    },
  },
  watch: {
    selectedMaps: function (n) {
      // console.log(n);
      if (n[0]) {
        this.selectedMap = n[0];
        return;
      }
      this.selectedMap = null;
    },
    endFirstAuth: function () {//, oldR
      if (!this.isSignedIn) {
        this.$store.commit('addMessage', {
          text: `ログインが必要です`,
        });
        this.$router.push("/");
        return;
      }
    },
    user: function () {
      if (this.initialized) {
        return;
      }
      if (this.user && this.user.rand) {
        console.log("initialized:3");
        this.init();
        this.initialized = true;
      }
    }
  }
};
</script>
